import { Budget } from '@/types/financial';
import { useMemo } from 'react';

export const useBudgetSelectors = (budgets: Budget[]) => {
  return useMemo(() => ({
    getById: (id: string) =>
      budgets.find(b => b.id === id),
    
    getByCategory: (categoryId: string) =>
      budgets.filter(b => b.categoryId === categoryId),
    
    getByPeriod: (period: string) =>
      budgets.filter(b => b.period === period),
    
    getActive: () =>
      budgets,
    
    getTotalBudgeted: () =>
      budgets.reduce((sum, b) => sum + b.amount, 0),
    
    getTotalSpent: () =>
      budgets.reduce((sum, b) => sum + (b.spent || 0), 0),
  }), [budgets]);
};
